"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = __importDefault(require("@emotion/css"));
const styled_1 = __importDefault(require("../utils/styled"));
const caretSize = 6;
const getCaretPosition = ({ position }) => {
    switch (position) {
        case "top":
            return css_1.default `
        top: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
      `;
        case "right":
            return css_1.default `
        top: 50%;
        left: ${caretSize * -2}px;
        transform: translateY(-50%);
      `;
        case "bottom":
            return css_1.default `
        top: ${caretSize * -2}px;
        left: 0;
        right: 0;
        margin: 0 auto;
      `;
        case "left":
            return css_1.default `
        top: 50%;
        left: 100%;
        transform: translateY(-50%);
      `;
    }
};
const Container = styled_1.default.div `
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  z-index: ${({ theme }) => theme.zIndex.tooltip};
  padding: ${({ theme }) => theme.space.base}px ${({ theme }) => theme.space.small}px;
  background-color: ${({ theme }) => theme.color.primaryDark};
  color: ${({ theme }) => theme.color.white};
  font-size: ${({ theme }) => theme.font.size.fineprint}px;
  border-radius: 2px;
  white-space: pre;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  transform: ${({ position }) => {
    switch (position) {
        case "top":
            return "translate(-50%, -100%)";
        case "bottom":
            return "translateX(-50%)";
        case "left":
            return "translate(-100%, -50%)";
        case "right":
            return `translateY(-50%)`;
    }
}};

  /* Caret */
  ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: ${caretSize}px solid transparent;
    ${({ theme, position }) => `border-${position}-color: ${theme.color.primaryDark}`};
    ${getCaretPosition}
  }
`;
exports.default = Container;
//# sourceMappingURL=Tooltip.Container.js.map